import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Toaster } from './components/ui/toaster';

import PreLoader from './components/PreLoader';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import UptimeDashboard from './components/UptimeDashboard';
import About from './components/About';
import Services from './components/Services';
import Industries from './components/Industries';
import Pricing from './components/Pricing';
import WhyChoose from './components/WhyChoose';
import WorldMap from './components/WorldMap';
import StatsBanner from './components/StatsBanner';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import PartnersSection from './components/PartnersSection';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import CloudVCSection from './components/CloudVCSection';
import { QuoteProvider } from './components/QuoteContext';

const Home = () => (
  <>
    <Navbar />
    <Hero />
    <UptimeDashboard />
    <About />
    <Services />
    <Industries />
    <CloudVCSection />
    <WorldMap />
    <Pricing />
    <WhyChoose />
    <StatsBanner />
    <CaseStudies />
    <Testimonials />
    <PartnersSection />
    <FAQ />
    <Footer />
  </>
);

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.body.style.overflow = loading ? 'hidden' : 'auto';
  }, [loading]);

  return (
    <div className="App">
      <AnimatePresence>
        {loading && <PreLoader onFinish={() => setLoading(false)} />}
      </AnimatePresence>
      <BrowserRouter>
        <ScrollToTop />
        <QuoteProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
          </Routes>
        </QuoteProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
